import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';
import { EligibleToEditStatuses } from '../../enums/fulfillmentplan-order-grid-status';

export const useCanUnlink = (fulfillmentPlanId, salesOrderId) => {
  const fulfillmentPlan = useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId })) ?? {};
  const { items: fpItems, orderGridStatus, salesOrdersFulfilledIds } = fulfillmentPlan;
  const salesOrder = useSelector((state) => Global.selectEntitiesSalesOrderById(state, { salesOrderId }));

  if (salesOrdersFulfilledIds.length < 2) {
    return false;
  }

  if (!EligibleToEditStatuses.includes(orderGridStatus)) {
    return false;
  }

  const fpSalesOrderItemIds = fpItems.map(({ salesOrderItemId }) => salesOrderItemId);
  const doesFulfillmentPlanHaveAnItemForSalesOrder = salesOrder.items.some((soItem) =>
    fpSalesOrderItemIds.includes(soItem.salesOrderItemId),
  );
  if (doesFulfillmentPlanHaveAnItemForSalesOrder) {
    return false;
  }

  return true;
};
